import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router'
import Settings from './Settings';
import Auth from './Auth';
import Common from './Common';
import Customer from './Customer';
import Users from './Users'
import Misc from './Misc'
import Compliance from "./Compliance";
import Insider from "./Insider";
import BreachRisk from "./BreachRisk";
import Admin from "./Admin";


export default (history) => combineReducers({
  router: connectRouter(history),
  settings: Settings,
  auth: Auth,
  common: Common,
  customer: Customer,
  users: Users,
  misc: Misc,
  compliance: Compliance,
  insider: Insider,
  breachrisk: BreachRisk,
  admin: Admin,
});
